export default __webpack_public_path__ + "static/media/profile_default_crop.d28267f2.jpg";